/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import router from '@/router'
import { login, register, getProfile } from '@/api/user.js'
import auth from "@/auth/authService";

export default {
    loginAttempt({ dispatch }, payload) {

        // New payload for login action
        const newPayload = {
            userDetails: payload.userDetails,
            notify: payload.notify
        }

        dispatch('login', newPayload)

    },
    login({ commit, state, dispatch }, payload) {
        // If user is already logged in notify and exit
        if (state.isUserLoggedIn()) {
            console.log('123')
            payload.notify({
                title: '尝试登录',
                text: '你已经登录啦！正在帮你跳转喔～',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
            });
            setTimeout(() => {
                router.push('/')
            }, 1000)
            
            return false
        }
        let formData = {
            'username': payload.userDetails.username,
            'password': payload.userDetails.password,
            'loginType': 'password'
        }
        login(formData).then((res) => {
            if (res.code === 1) {
                commit('SET_TOKEN', res.data);
                auth.handleAuthentication().then((res)=>{
                    if (auth.isAuthenticated()) router.push(router.currentRoute.query.to || '/');
                });
            }
        })
    },

    registerUser({dispatch}, payload) {

            register({
                username: payload.userDetails.username,
                password: payload.userDetails.password,
                roleType: 'user'
            }).then((res) => {
                if (res.code === 1) {
                    payload.notify({
                        title: '账号创建成功',
                        text: '你已经注册成功啦！',
                        iconPack: 'feather',
                        icon: 'icon-check',
                        color: 'success'
                    });
    
                    const newPayload = {
                        userDetails: payload.userDetails,
                        notify: payload.notify,
                        updateUsername: true
                    }
                    dispatch('login', newPayload)
                }
            })
    },
    updateUsername({ commit }, payload) {
        getProfile().then((res) => {

            // If username update is success
              // update in localstorage
            let newUserData = Object.assign({}, res.data.info)
            newUserData.displayName = res.data.info.nickname
            commit('UPDATE_AUTHENTICATED_USER', newUserData)

            // If reload is required to get fresh data after update
              // Reload current page
            if(payload.isReloadRequired) {
                router.push(router.currentRoute.query.to || '/')
            }
        }).catch((err) => {
              payload.notify({
                time: 8800,
                title: 'Error',
                text: err.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            });
        })
    },
    updateAuthenticatedUser({ commit }, payload) {
        commit('UPDATE_AUTHENTICATED_USER', payload)
    }
}
